/**
 * Privacy Badge — Subtle visibility label for items
 */
import { Users, User } from "lucide-react";

export function PrivacyBadge({ visibility = "shared" }) {
  if (visibility === "personal") {
    return (
      <span className="inline-flex items-center gap-1 text-[10px] font-medium text-muted-foreground bg-muted px-2 py-0.5 rounded-full" data-testid="privacy-badge-personal">
        <User className="w-3 h-3" />
        Personal
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1 text-[10px] font-medium text-[#1a4d3e] bg-[#1a4d3e]/10 px-2 py-0.5 rounded-full" data-testid="privacy-badge-shared">
      <Users className="w-3 h-3" />
      Shared
    </span>
  );
}
